import { Color } from '../../../../core/models/entities/LogoOptions'
import { isBackupWhiteRow } from '../../../../utils/systemColors'

function ColorBlock({ color, colorHex, size = 'md' }: { color?: Color, colorHex?: string, size?: 'sm' | 'md' }) {
  // The white-backup LAYER row renders as a WHITE swatch with a visible
  // border: the stored RGB is the logo system's pale-blue stand-in for white
  // backup foil (customer case 21/8, code "0821") — showing that blue told
  // customers their logo contained a colour it does not have. Identity-gated:
  // catalog rows carry isBackup as "printed WITH white backup" and must keep
  // their real colour swatch (regression 21-25/8).
  if (color && isBackupWhiteRow(color)) {
    return <BlockBase size={size} background={'#ffffff'} bordered />
  }
  const styleString = color ? `rgb(${color.red}, ${color.green}, ${color.blue})` : colorHex?.charAt(0) === '#' ? colorHex : `#${colorHex!}`

  return <BlockBase size={size} background={styleString} />
}

export function BlockBase({ background, size, bordered = false }: { size: 'sm' | 'md', background: string, bordered?: boolean }) {
  const border = bordered ? ' border border-gray-400' : ''
  switch (size) {
    case 'sm':
      return <div style={{ background }}
                  className={`inline-block min-h-2 min-w-2 h-3 w-3 m-[1.5px] rounded-[1px]${border}`} />
    case 'md':
      return <div style={{ background }}
                  className={`inline-block min-h-3.5 min-w-3.5 h-3.5 w-3.5 m-[1.5px] rounded${border}`} />
  }
}


export default ColorBlock